<template>
  <div class="text-table">
    <el-table :data="tabData"
              :border="border"
              :stripe="true"
              :height="height"
              style="width: 100%"
              :show-summary="summary"
              :summary-method="getSummaries">
      <el-table-column v-if="showIndex"
                       label="#"
                       align="center"
                       fixed
                       type="index"
                       width="40">
      </el-table-column>
      <el-table-column v-for="item in tagData"
                       :key="item.prop"
                       :prop="item.prop"
                       :label="item.label"
                       :width="item.width"
                       :min-width="item.widths"
                       :fixed="item.fixed"
                       :align="item.align">
        <template slot-scope="prop">
          <div v-if="item.slot">
            <slot :name="item.prop"
                  :row="prop.row"
                  :index="prop.$index"></slot>
          </div>
          <span class="table-cell-span"
                v-else>{{prop.row[item.prop]}}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作"
                       v-if="showEdit"
                       :width="widths"
                       align="left"
                       fixed="right">
        <template slot-scope="scope">
          <slot name="operator"
                :row="scope.row"
                :index="scope.$index"></slot>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    widths: {
      type: [String, Number],
      default: '70'
    },
    showEdit: {
      type: Boolean,
      default: false
    },
    tagData: {
      required: true
    },
    tabData: {
      default () {
        return []
      }
    },
    border: {
      default: false
    },
    showIndex: {
      default: true
    },
    height: {
      type: [String, Number]
    },
    summary: { // 是否在表尾显示合计行
      type: Boolean,
      default: false
    },
    getSummaries: { // 自定义合计计算方法
      type: Function,
      default: function () {
      }
    }
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="scss">
.text-table .el-table .el-table__cell{
  padding: 14px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/components/table.vue